export default "__VITE_ASSET__Ddd9nxJe__"